import React, {useEffect, useState} from 'react';
import {Modal, ModalHeader, ModalBody, ModalFooter, Button} from 'reactstrap';
import * as commonActions from '@common/common.action';
import ArqivamentoApi from '../../../../arquivamento.api';
import {arquivamentoManualTipoOptions, arquivamentoManualTipoEmum} from '../../../../arquivamento.utils';
import {useDispatch} from 'react-redux';
import Filtros from './Filtros';
import Table from './Table';
import ModalLocalizacao from './Localizacao';
import CommonFunctions from '@common/util/functions.common';
import IntlMessage from '../../../../../../helpers/intlMessage';
import {useIntl} from 'react-intl';
import {changePeriod, getDate, obterListagemDePeriodos} from '../../../../../../helpers';

export default function ModalArquivamentoManual(props) {
  const intl = useIntl()
  const periodo = CommonFunctions.getPeriodosSubDays(0);
  const backdrop = !props.backdrop ? false : props.backdrop;
  const keyboard = props.keyboard === undefined ? true : props.keyboard;
  const dispatch = useDispatch();
  const [showModalLocalizacao, setShowModalLocalizacao] = useState(false);
  const [localizacaoArquivamento, setLocalizacaoArquivamento] = useState('');
  const [motivoArquivamento, setMotivoArquivamento] = useState('');
  const [locaisAnteriores, setLocaisAnteriores] = useState([]);
  const [modalAberto, setModalAberto] = useState(false);
  const [numeroDoExame, setNumeroDoExame] = useState('');
  const [dataInicial, setDataInicial] = useState(periodo.periodoInicial);
  const [dataFinal, setDataFinal] = useState(periodo.periodoFinal);
  const [tipoSelecionado, setTipoSelecionado] = useState(arquivamentoManualTipoOptions.find(x => x.value === arquivamentoManualTipoEmum.BLOCO_LAMINA));
  const [lista, setLista] = useState([]);
  const [listaItensSelecionados, setListaItensSelecionados] = useState([]);
  const [tipoPeriodo, setTipoPeriodo] = useState({value: 'hoje', label: `${intl.formatMessage({id: "period.today"})}`});
  const functionObterListagemDePeriodos = obterListagemDePeriodos.bind(this);
  const functionGetDate = getDate.bind(this);
	const functionChangePeriod = changePeriod.bind(this);
  const periodos = functionObterListagemDePeriodos(intl);

  useEffect(() => {
    setModalAberto(props.showModalArquivamentoManual);
    dispatch(commonActions.showModal(props.showModalArquivamentoManual));
    setLista([]);
  }, [props.showModalArquivamentoManual]);

  function toggle() {
    setModalAberto(!modalAberto);
    dispatch(commonActions.showModal(!modalAberto));
    props.onModal(!modalAberto);
  }

  function onChangeData(name, value) {
    if (name === 'dataInicial') {
      setDataInicial(value);
    } else {
      setDataFinal(value);
    }
  }

  function onClickFiltrar() {
    if ((numeroDoExame == null || numeroDoExame == '') &&
        (dataInicial == null || dataInicial == '') &&
        (dataFinal == null || dataFinal == '')) {
      dispatch(commonActions.showAlerta('alerta', intl.formatMessage({id: 'dashboards.general.noFilteredItems'}), 3000));
      return;
    }

    let executarValidacaoDeData = (dataInicial != null && dataInicial != '') || (dataFinal != null && dataFinal != '');
    let result = {valid: true, message: ''};

    if (executarValidacaoDeData)
      result = CommonFunctions.validaData(dataInicial, dataFinal, intl);

    if (!result.valid) {
      dispatch(commonActions.showAlerta('alerta', result.message, 3000));
      return;
    }

    filtrar({tipoSelecionado, dataInicial, dataFinal, numeroDoExame});
  }

  function filtrar(objPesquisa) {
    const {tipoSelecionado, dataInicial, dataFinal, numeroDoExame} = objPesquisa;

    dispatch(commonActions.showFadeCarregando(true));
    ArqivamentoApi.getArquivamentoManual(tipoSelecionado.value, dataInicial, dataFinal, numeroDoExame).then(resp => {
      setLista(resp);
      dispatch(commonActions.showFadeCarregando(false));
      props.showMessageByResults(resp.length);
    });
  }

  function salvar() {
    const item = {
      itens: listaItensSelecionados,
      localizacao: localizacaoArquivamento,
      motivo: motivoArquivamento
    };

    dispatch(commonActions.showFadeCarregando(true));

    ArqivamentoApi.postArquivamento(item).then(resp => {
      dispatch(commonActions.showFadeCarregando(false));

      let listaTemp = lista;
      listaItensSelecionados.forEach(x => {
        listaTemp = listaTemp.filter(item => item.idMaterial !== x.idMaterial);
      });

      setLista(listaTemp);
      setShowModalLocalizacao(false);
      dispatch(commonActions.showAlerta('sucesso', <IntlMessage id="general.materialArchiving.archivingDoneSuccessfully"/>, 3000));
    });
  }

  function onClickConfirmar() {
    const itens = listaItensSelecionados.map(i => {
      const item = lista.find(x => x.idMaterial === i.idMaterial);
      return {
        tipo: item.tipo,
        value: item.idMaterial,
        label: item.numeroMaterial
      };
    });

    dispatch(commonActions.showFadeCarregando(true));

    ArqivamentoApi.getItemsRequisicaoPorIdentificacao(itens).then(resp => {
      dispatch(commonActions.showFadeCarregando(false));
      setShowModalLocalizacao(false);
      setShowModalLocalizacao(!showModalLocalizacao);
      setLocalizacaoArquivamento('');
      setMotivoArquivamento('');
      setLocaisAnteriores(resp);
    });
  }

  function resetarPeriodo() {
		setTipoPeriodo('');
    setDataInicial(null);
    setDataFinal(null);
	}

	function periodoAlterado(e) {
		if (!e || !e.value) {
		  return resetarPeriodo();
		}

		let payload = functionGetDate(e.value);
		payload.dtinicial = payload.dtinicial.toISOString().slice(0, 10);
		payload.dtfinal = payload.dtfinal.toISOString().slice(0, 10);

    setTipoPeriodo(e);
    setDataInicial(payload.dtinicial);
    setDataFinal(payload.dtfinal);
	}

	function mudarIntervaloPeriodo(val) {
		let payload = functionChangePeriod(val);

    setDataInicial(payload.start);
    setDataFinal(payload.end);
	}

	function eventoOnKeyPressData(event) {
		if (event.key === "Enter")
				onClickFiltrar();
	}

  return (
    <React.Fragment>
      <div>
        <ModalLocalizacao
          onModal={() => setShowModalLocalizacao(!showModalLocalizacao)}
          locaisAnteriores={locaisAnteriores}
          localizacaoArquivamento={localizacaoArquivamento}
          setLocalizacaoArquivamento={setLocalizacaoArquivamento}
          motivoArquivamento={motivoArquivamento}
          setMotivoArquivamento={setMotivoArquivamento}
          showModalLocalizacao={showModalLocalizacao}
          salvar={salvar}
        />
        <Modal
          className='modal-xl'
          backdrop={backdrop}
          keyboard={keyboard}
          isOpen={modalAberto}
          toggle={toggle}
        >
          <ModalHeader toggle={!props.close ? toggle : props.close}>
            <IntlMessage id="general.materialArchiving.manualArchiving" />
          </ModalHeader>

          <ModalBody>
            <Filtros
              dataInicial={dataInicial}
              dataFinal={dataFinal}
              tipoSelecionado={tipoSelecionado}
              onChangeData={onChangeData}
              onChageTipo={setTipoSelecionado}
              onClickFiltrar={onClickFiltrar}
              onChangeNumeroExame={e => setNumeroDoExame(e.target.value)}
              periodo={tipoPeriodo}
              periodos={periodos}
              onChangePeriodo={periodoAlterado}
					    mudarIntervaloPeriodo={mudarIntervaloPeriodo}
					    onKeyPressData={eventoOnKeyPressData}
            />
            <Table
              lista={lista}
              setListaItensSelecionados={setListaItensSelecionados}
            />
          </ModalBody>

          <ModalFooter>
            <Button
              onClick={!props.cancelar ? toggle : props.cancelar}
              className={`button-cancel`}
              color='secondary'
              style={{marginRight: '10px'}}
            >
              <IntlMessage id="general.materialArchiving.close" />
            </Button>
            <Button
              color='primary'
              disabled={!listaItensSelecionados.length}
              onClick={onClickConfirmar}
            >
              <IntlMessage id="general.materialArchiving.confirm" />
            </Button>
          </ModalFooter>
        </Modal>
      </div>
    </React.Fragment>
  );
}



// WEBPACK FOOTER //
// ./src/pages/arquivamento/tabs/Arquivamento/modais/ArquivamentoManual/index.js